import React, { useEffect, useState } from 'react';
import { Container } from '@material-ui/core';
import { Login } from '../login';
import HomepageUser from './homepage-user';
import { isLoggedIn } from '../../data';

export default function Homepage(props) {
    const [recognized, setRecognized] = useState(false);
    useEffect(() => {
        (async () => {
            setRecognized(await isLoggedIn());
        })();
    }, []);
    return (
        <Container>
            {!recognized && <Login setRecognized={setRecognized} />}
            {recognized && <HomepageUser />}
        </Container>
    )
}